import { Text, View,Image,TouchableOpacity, useWindowDimensions,} from 'react-native-web';
import {DrawerContentScrollView, DrawerItemList} from '@react-navigation/drawer';
import { auth } from '../component/firebase/FirebaseConfig'
import { signOut } from 'firebase/auth'
import Ionicons from 'react-native-vector-icons/Ionicons';
import React from 'react'
import * as WebBrowser from 'expo-web-browser';

const LogOut = () =>{signOut(auth);};

const DrawerCustom = (props) => {
  const windows=useWindowDimensions();
  async function handlePress () {
    await WebBrowser.openBrowserAsync('https://chat.whatsapp.com/HJcJVchsw3lESVf4kZ9Zhs');
  }


  return (
        <View style={{flex:1}}>
          <DrawerContentScrollView {...props} style={{}} >
             <View style={{justifyContent:'center', alignItems:'center'}}>      
                 <Image resizeMode='contain' style={{width:windows.width*0.1,height:windows.height*0.1,minHeight:100,minWidth:300,marginTop:15,alignSelf:'center', shadowColor:'#000000', shadowRadius:2.5, shadowOpacity:1,shadowOffset:{width:5,height:5}}} source={require('../assets/logoGold.png')}/>
             </View>    
             <View style={{flex:1, backgroundColor:'#303030', paddingTop:10}}>
                 <DrawerItemList {...props}/>
             </View> 
             <Ionicons name='arrow-back-outline' size={24} color='#F9BA49' style={{position:'absolute', top:30, left:15}} onPress={()=>{props.navigation.closeDrawer()}}/>
          </DrawerContentScrollView>
          <View style={{padding:20}}>
          <TouchableOpacity onPress={()=>{handlePress()}} style={{paddingVertical:15}}>
                 <View style={{flexDirection:'row', alignItems:'center'}}>
                  <Ionicons name="logo-whatsapp" size={22} style={{color:'#7c7d7e'}}/>
                  <Text style={{fontSize:15, marginLeft: 5, color:'#7c7d7e'}}>Gruppo Whatsapp</Text>
                 </View>
             </TouchableOpacity>
             <TouchableOpacity onPress={()=>{}} style={{paddingVertical:15}}>
                 <View style={{flexDirection:'row', alignItems:'center'}}>
                  <Ionicons name="share-social-outline" size={22} style={{color:'#7c7d7e'}}/>
                  <Text style={{fontSize:15, marginLeft: 5, color:'#7c7d7e'}}>Condividi</Text>
                 </View>
             </TouchableOpacity>
             <TouchableOpacity onPress={()=>{LogOut()}} style={{paddingVertical:15}}>
                 <View style={{flexDirection:'row', alignItems:'center'}}>
                  <Ionicons name="exit-outline" size={22} style={{color:'#7c7d7e'}}/>  
                  <Text style={{fontSize:15, marginLeft: 5, color:'#7c7d7e'}}>Log-Out</Text>
                 </View>
             </TouchableOpacity>
       </View>  
      </View>);}

export default DrawerCustom